import React from 'react';
import Header from '../components/Header';
import Menu from '../components/Menu';
import Footer from '../components/Footer';

/**
 * Standard layout component to frame freestanding React web applications and
 * seamlessly match with all other pages on the Boston.gov site.
 *
 * Provides a skip link to main content and Boston.gov site navigation,
 * header, and footer.
 *
 * Includes options to pass in a secondary navigation component, as well as
 * the breadcrumb navigation component.
 */
export default function AppLayout(_ref) {
  var secondaryNav = _ref.secondaryNav,
      breadcrumbNav = _ref.breadcrumbNav,
      children = _ref.children;
  return React.createElement(React.Fragment, null, React.createElement("a", {
    href: "#content-start",
    tabIndex: 1,
    className: "btn a11y--h a11y--f",
    style: {
      margin: 4
    },
    onClick: function onClick(ev) {
      return ev.currentTarget.blur();
    }
  }, "Jump to content"), React.createElement(Menu, null), React.createElement("div", {
    className: "mn--full-ie"
  }, React.createElement("div", {
    className: "mn mn--full ".concat(secondaryNav ? 'mn--nv-s' : '')
  }, React.createElement(Header, null), secondaryNav, secondaryNav ? React.createElement(React.Fragment, null, breadcrumbNav) : React.createElement("div", {
    className: "p-t300"
  }, breadcrumbNav), React.createElement("div", {
    id: "content-start",
    className: "a11y--content-start"
  }), React.createElement("main", {
    className: "b-ff"
  }, children))), React.createElement(Footer, {
    style: {
      position: 'relative',
      zIndex: 2
    }
  }));
}